"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMultiShadeProduct = void 0;
const isMultiShadeProduct = ({
  shades
}) => shades && shades.length > 1;
exports.isMultiShadeProduct = isMultiShadeProduct;
//# sourceMappingURL=isMultiShadeProduct.js.map